import { component } from "picoapp";
import { formatMoney, currencySymbol } from "../lib/currency";
import $ from "jquery";

export default component(async (node) => {
  const [{ default: Flickity }] = await Promise.all([
    import("flickity"),
    import("flickity-as-nav-for"),
    import("flickity-fade"),
    import("flickity-imagesloaded"),
  ]);
  const slider = node.querySelector(".js-product-slider");
  let flkty = "";

  if (slider) {
    flkty = new Flickity(slider, {
      setGallerySize: false,
      fade: true,
      imagesLoaded: true,
      draggable: false,
    });
  }

  const options = node.querySelectorAll('input[type="radio"]');

  const $productTitle = $(node).find(".product-title-link");
  const productUrl = $productTitle.attr("href");

  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    option.addEventListener("click", () => {
      /* Select image variant */
      $(".alt-image").removeClass("is-hover is-tapped");
      const selectedSlide = flkty.slides.find((slide) => {
        const slideElement = slide.cells[0].element;
        return (
          parseInt(slideElement.dataset.variantId) ===
          parseInt(option.dataset.vid)
        );
      });
      const selectedSlideElement = selectedSlide.cells[0].element;
      flkty.select(parseInt(selectedSlideElement.dataset.slideIndex));
      node
        .querySelectorAll("[data-old-compare-at-price]")
        .forEach((compareAtPriceNode) => {
          compareAtPriceNode.innerHTML =
            parseInt(selectedSlideElement.dataset.compareAtPrice) > 0
              ? `${currencySymbol()}${formatMoney(
                  selectedSlideElement.dataset.compareAtPrice,
                  "{{ amount_no_trailing_zeroes }}",
                  false
                )}`
              : "";
        });
      node.querySelectorAll("[data-old-price]").forEach((priceNode) => {
        priceNode.innerHTML =
          parseInt(selectedSlideElement.dataset.price) > 0
            ? `${currencySymbol()}${formatMoney(
                selectedSlideElement.dataset.price,
                "{{ amount_no_trailing_zeroes }}",
                false
              )}`
            : "";
      });

      /* Change product title's url to variant */
      const variantId = option.dataset.vid;
      $productTitle.attr("href", `${productUrl}?variant=${variantId}`);

      const ctas = node.querySelectorAll(".add-to-bag__button-container");
      for (let j = 0; j < options.length; j++) {
        if (ctas.length) {
          ctas[j].classList.remove("active");
        }
      }
      if (ctas.length) {
        ctas[i].classList.add("active");
      }
    });
  }
});
